import { z } from 'zod';

export const authUserResponseSchema = z.object({
  authTime: z.coerce.number(),
  jti: z.string(),
  sub: z.string(),
  typ: z.string(),
  sid: z.string(),
  emailVerified: z.preprocess(
    (val) => (typeof val === 'string' ? val.toLowerCase() === 'true' : val),
    z.boolean()
  ),
  name: z.string(),
  preferredUsername: z.string(),
  givenName: z.string(),
  familyName: z.string(),
  email: z.string(),
});

export type AuthUserResponse = z.infer<typeof authUserResponseSchema>;
